import React, {useState} from 'react'
import NoSSR from '@components/NoSSR'
import PDFViewer from '@components/PdfViewer'
import SuspenseLoading from '@components/SuspenseLoading'
import {getWebsiteEMenu_emenu} from '@data/queries/website/__generated__/getWebsiteEMenu'
import useWidth from '@hooks/useWidth'
import Container from '@packages/justo-parts/lib/components/Container'

import CollectEmail from './CollectEmail'
import DynamicPage from './DynamicPage'

import styles from './styles.module.css'

export interface EMenuProps {
  emenu: getWebsiteEMenu_emenu
}

export default function EMenu(props: EMenuProps) {
  const {emenu} = props

  const [numPages, setNumPages] = useState(null)

  function onDocumentLoadSuccess({numPages}) {
    setNumPages(numPages)
  }

  // to listen to resizes
  useWidth()

  if (!emenu) return null
  if (!emenu.file) return null

  return (
    <>
      {emenu.collectEmails ? <CollectEmail emenu={emenu} /> : null}
      <div className={styles.container}>
        <NoSSR>
          <SuspenseLoading>
            <DynamicPage emenuId={emenu._id} />
          </SuspenseLoading>
        </NoSSR>
        <Container>
          <PDFViewer file={emenu.file.url} />
        </Container>
      </div>
    </>
  )
}
